import React from 'react';
import {appText} from '../../assets/text/appText';
import Button from '../Buttons/Button';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  onCreate: () => void;
  canCreateCourses: boolean;
}

const MicrolessonsEmptyState = ({onCreate, canCreateCourses}: Props) => {
  return (
    <div className="EmptyStateContainer">
      <Icon name="microlesson.svg" className="SpanIcon" />
      <p className="Title">{appText.noMicrolessonsInfo1}</p>
      <p className="Title">{appText.noMicrolessonsInfo2}</p>
      {canCreateCourses && (
        <Button
          onClick={onCreate}
          title={appText.createLesson}
          uiType="secondary"
          icon="icon-plus"
          className="CreateButton"
        />
      )}
    </div>
  );
};

export default MicrolessonsEmptyState;
